import { EditorPage } from "./EditorPage";

import type { FeatureModule } from "@/types/feature";

/**
 * Editing surface. No sidebar tool entry — editors reach it from the
 * "Edit this page" affordance on manual pages and "+ New page" on section
 * landings. Server-side, every editing route requires cms.edit.
 */
export const editorFeature: FeatureModule = {
  id: "editor",
  navItems: [],
  routes: [{ path: "edit/:pageId", element: <EditorPage /> }],
};
